import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../styles/menu.css";
import { NavLink } from "react-router-dom";
import packageJson from "../../../package.json";
import uRLs from "../../utiles/BaseUtile";

function Menu({ open, setOpen }) {

  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);
  const [expandedMenu, setExpandedMenu] = useState({});
  const logo = process.env.REACT_APP_MENU_LOGO_URL;
  // const handleToggleMenu = (menuId) => {
  //   setExpandedMenu((prevMenu) => ({
  //     ...prevMenu,
  //     [menuId]: !prevMenu[menuId],
  //   }));
  // };

  const handleLinkClick = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const pathToMenuMap = {
      "/api-keys": "integrate",
    };

  const activeMenu = pathToMenuMap[location.pathname];
    if (activeMenu) {
      setExpandedMenu((prevMenu) => ({
        ...prevMenu,
        [activeMenu]: true,
      }));
    }
  }, [location.pathname]);
  
  const getWrapperClass = () => {
    if (window.innerWidth < 768) {
      return `wrapper ${open ? "toggled" : ""}`;
    } else {
      return "wrapper";
    }
  };

  const sidebarClass = open ? "sidebar-wrapper" : "sidebar-wrapper closed";

  return (
    <>
      <div className={getWrapperClass()}>
        <div className="overlay toggle-icon" onClick={handleLinkClick}></div>
        <div className={sidebarClass} data-simplebar="true">
          <div className="sidebar-header">
            <div className="logo-container">
              {isMobile ? (
                <div className="d-flex">
                  <img src={logo} className="logo-image" alt="logo icon" />
                  <div
                    className="toggle-icon ms-auto"
                    onClick={() => setOpen(!open)}
                  >
                    <i className="bx bx-arrow-back text-white mt-2"></i>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center">
                  <img src={logo} className="ms-5 me-5 w-85" alt="logo icon" />
                </div>
              )}
            </div>
          </div>

          {open && (
            <ul className="metismenu" id="menu">
              <li>
                <NavLink
                  to="/dashboard"
                  onClick={handleLinkClick}
                  className={location.pathname === "/dashboard" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-home"></i>
                  </div>
                  <div className="menu-title">Dashboard</div>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/all-stores"
                  onClick={handleLinkClick}
                  className={location.pathname === "/all-stores" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-store"></i>
                  </div>
                  <div className="menu-title">All Stores</div>
                </NavLink>
              </li>
           
            </ul>
          )}

          <footer className="menu-footer text-center booy-tstab p-2 text-white">
            <span className="pe-3"> Version: {packageJson.version}</span>
            <span className="pe-3"> {uRLs.ENV_NAME}</span>
          </footer>
        </div>
      </div>
    </>
  );
}

export default Menu;
